import React, { useState, useEffect } from "react";
import SEO from "../seo";
const Appss = () => {
  const [activeSection, setActiveSection] = useState("overview");

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["overview", "app-types", "what-to-expect"];

      const scrollPosition = window.scrollY + 100;

      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (
            scrollPosition >= offsetTop &&
            scrollPosition < offsetTop + offsetHeight
          ) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="flex flex-col lg:flex-row gap-6">
      <SEO
        title="Apps | xPage Help Center"
        description="Explore the upcoming Xpage App ecosystem. Learn about official, third-party, and custom apps to extend your store's capabilities, manage settings, and streamline operations."
        keywords="xPage apps, Xpage app types, third-party apps, custom apps, store apps, ecommerce app ecosystem"
        canonical="https://help.xpage.ai/help/apps/apps"
        type="article"
      />

      {/* Main Content */}
      <div className="flex-1 prose max-w-none">
        {/* Header Section */}
        <header id="overview" className="mb-6 scroll-mt-20">
          <h1 className="text-systemTitle text-2xl font-semibold mb-3">Apps</h1>
          <p className="text-sm text-systemLabel">
            Xpage is building a powerful ecosystem of apps to help you build,
            manage, and grow your online store , all in one place.
          </p>
          <p className="text-sm text-systemLabel">
             you'll be able to explore, install, and manage a variety of
            apps designed to simplify your workflow, enhance your customer
            experience, and connect every part of your business — from payments
            and logistics to analytics and marketing.
          </p>
        </header>

        {/* App Types Section */}
        <section id="app-types" className="mb-6 scroll-mt-20">
          <h2 className="text-sm font-semibold text-systemTitle mb-1">
            App Types 
          </h2>

          <div className="bg-systemBackground border border-systemBorder rounded-lg p-4 mt-2">
            <div className="space-y-4">
              <table className="w-full mb-4">
                <tbody className="border divide-y divide-systemBorder">
                  <tr className="bg-gray-400/10 transition-colors">
                    <td className="p-3 align-top w-1/3 border-r border-systemBorder">
                      <strong className="text-systemTitle text-sm">
                        Official Xpage Apps
                      </strong>
                    </td>
                    <td className="p-3 align-top text-systemLabel text-sm">
                      Developed and maintained by Xpage, these apps will be
                      fully integrated into the platform, covering essential
                      areas like store setup, analytics, and payment processing.
                    </td>
                  </tr>
                  <tr className="">
                    <td className="p-3 align-top w-1/3 border-r border-systemBorder">
                      <strong className="text-systemTitle text-sm">
                        Third-Party Apps
                      </strong>
                    </td>
                    <td className="p-3 align-top text-systemLabel text-sm">
                      Built by trusted developers to extend your store's
                      capabilities with industry-specific tools and
                      integrations.
                    </td>
                  </tr>
                  <tr className="bg-gray-400/10 transition-colors">
                    <td className="p-3 align-top w-1/3 border-r border-systemBorder">
                      <strong className="text-systemTitle text-sm">
                        Custom Apps
                      </strong>
                    </td>
                    <td className="p-3 align-top text-systemLabel text-sm">
                      Tailored solutions created specifically for your business,
                      offering unique functionality not available in the public
                      App Store.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* What to Expect Section */}
        <section id="what-to-expect" className="scroll-mt-20">
          <h2 className="text-sm font-semibold text-systemTitle mb-1">
            What to Expect
          </h2>

          <div className="bg-systemBackground border border-systemBorder rounded-lg p-4 mt-2">
            <div className="space-y-4">
              <table className="w-full mb-4">
                <tbody className="border divide-y divide-systemBorder">
                  <tr className="bg-gray-400/10 transition-colors">
                    <td className="p-3 align-top w-1/3 border-r border-systemBorder">
                      <strong className="text-systemTitle text-sm">
                        Extend Store Capabilities
                      </strong>
                    </td>
                    <td className="p-3 align-top text-systemLabel text-sm">
                      Connect your store with advanced apps and open APIs to
                      automate workflows and streamline operations.
                    </td>
                  </tr>
                  <tr className="">
                    <td className="p-3 align-top w-1/3 border-r border-systemBorder">
                      <strong className="text-systemTitle text-sm">
                        Discover & Install
                      </strong>
                    </td>
                    <td className="p-3 align-top text-systemLabel text-sm">
                      Browse the upcoming Xpage App Store to find the right
                      tools for your business.
                    </td>
                  </tr>
                  <tr className="bg-gray-400/10 transition-colors">
                    <td className="p-3 align-top w-1/3 border-r border-systemBorder">
                      <strong className="text-systemTitle text-sm">
                        Configure & Manage
                      </strong>
                    </td>
                    <td className="p-3 align-top text-systemLabel text-sm">
                      Control app settings, permissions, and data access — all
                      from a single dashboard.
                    </td>
                  </tr>
                  <tr className="">
                    <td className="p-3 align-top w-1/3 border-r border-systemBorder">
                      <strong className="text-systemTitle text-sm">
                        Support & Maintenance
                      </strong>
                    </td>
                    <td className="p-3 align-top text-systemLabel text-sm">
                      Get direct support from developers or the Xpage team
                      whenever you need assistance.
                    </td>
                  </tr>
                </tbody>
              </table>

           
            </div>
          </div>
        </section>
      </div>

      {/* Table of Contents Sidebar */}
      <div className="lg:w-64 flex-shrink-0 lg:block hidden">
        <div className="sticky top-6 bg-systemBackground border border-systemBorder rounded-lg p-4">
          <h3 className="text-systemTitle text-sm font-semibold mb-3">
            On this page
          </h3>
          <ul className="text-systemLabel text-sm space-y-2">
            <li>
              <a
                href="#overview"
                className={`block py-1 transition-colors border-l-2 pl-3 ${
                  activeSection === "overview"
                    ? "text-deepPurple font-semibold border-deepPurple"
                    : "border-transparent hover:text-deepPurple"
                }`}
              >
                Overview
              </a>
            </li>
            <li>
              <a
                href="#app-types"
                className={`block py-1 transition-colors border-l-2 pl-3 ${
                  activeSection === "app-types"
                    ? "text-deepPurple font-semibold border-deepPurple"
                    : "border-transparent hover:text-deepPurple"
                }`}
              >
                App Types
              </a>
            </li>
            <li>
              <a
                href="#what-to-expect"
                className={`block py-1 transition-colors border-l-2 pl-3 ${
                  activeSection === "what-to-expect"
                    ? "text-deepPurple font-semibold border-deepPurple"
                    : "border-transparent hover:text-deepPurple"
                }`}
              >
                What to Expect
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Appss;
